import React from 'react'
import classes from './Name.module.css'

const Name = (props) => {

    return (
        <div className={classes.name}>
            Илья Матвейчук
        </div>
    )
}

export default Name